import type { ReactElement } from 'react';

import { StyledIFrame } from './GoogleMapsEmbed.styled';
import type { GoogleMapsEmbedProps } from './GoogleMapsEmbed.types';

export const GoogleMapsEmbed = ({
  url,
}: GoogleMapsEmbedProps): ReactElement => {
  if (!url) return null;

  return <StyledIFrame src={url} title={url} />;
};
